


















import { Component, Vue } from 'vue-property-decorator'
import ContentLayout from '@/apps/open/layout/ContentLayout.vue'
import { priUrlReg } from '@/apps/open/constants'
import Button from '@components/Button'
import { ElForm } from 'element-ui/types/form'
import { testCertificateCallback, saveCertificateCallback, getCertificateCallback } from '@/apps/open/services/app'

@Component({
  components: {
    ContentLayout,
    Button
  }
})
export default class Callback extends Vue {
  form = {
    callback_url: ''
  }

  loading: boolean = false

  $refs!: {
    form: ElForm
  }

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }

  get rules () {
    const urlReg = new RegExp(priUrlReg, 'i')
    const urlRule = this.isPrivate ? { pattern: urlReg, message: '请输入正确的回调域名', trigger: ['blur', 'change'] } : { type: 'url', message: '请输入正确的回调域名', trigger: ['blur', 'change'] }
    return {
      callback_url: [
        { required: true, message: '请填写回调域名', trigger: ['blur', 'change'] },
        { min: 1, max: 255, message: '长度不超过255个字符', trigger: ['blur', 'change'] },
        urlRule
      ]
    }
  }

  get appId () {
    return this.$route.params.id
  }

  mounted () {
    this.getCallbackInfo()
  }

  async testCallback () {
    const params = {
      callback_addr: this.form.callback_url
    }
    const res = await testCertificateCallback(this.appId, params)
    if (res.data.result === 'ok') {
      let isValid = res.data.object.is_valid
      if (isValid) {
        this.$message.success(`通知成功`)
      } else {
        this.$message.error(`通知失败`)
      }
    }
  }

  saveCallbackConfig () {
    this.$refs.form.validate(async (valid: boolean) => {
      if (valid) {
        const params = {
          callback_addr: this.form.callback_url
        }
        const res = await saveCertificateCallback(this.appId, params)
        if (res.data.result === 'ok') {
          this.$message.success('保存成功')
        }
      }
    })
  }

  async getCallbackInfo () {
    const res = await getCertificateCallback(this.appId)
    if (res.data.result === 'ok') {
      const info = res.data.object
      this.form = {
        callback_url: info.callback_addr
      }
    }
  }
}
